import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import homeReducer from "./slices/homeSlice";
import categoryReducer from "./slices/categorySlice";
import modelReducer from "./slices/modelSlice";
import productReducer from "./slices/productSlice";
import calculatorReducer from "./slices/calculatorSlice";
import sellDeviceReducer from "./slices/sellDeviceSlice";
import serviceRequestReducer from "./slices/serviceRequestSlice";
import cityReducer from "./slices/citySlice";
import contactReducer from "./slices/contactSlice";
import profileReducer from "./slices/profileSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    home: homeReducer,
    category: categoryReducer,
    model: modelReducer,
    product: productReducer,
    calculator: calculatorReducer,
    sellDevice: sellDeviceReducer,
    serviceRequest: serviceRequestReducer,
    city: cityReducer,
    contact: contactReducer,
  },
});


